/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


$(document).ready(function() {

  if(window.location.hash.indexOf('#opencartdrawer') > -1) {
    document.getElementById('mini-cart').open = true;
    const url = window.location.href.replace("#opencartdrawer", "");
    history.replaceState(null, null, url);
  }
  
  $('.featured-product-list_grid.slider').each(function() {    
    var desktopSlidesToShow = parseInt($(this).attr('desktop_per_row'));
    var mobileSlidesToShow = parseInt($(this).attr('mobile_per_row'));    
    $(this).slick({
      dots: true,
      slidesToShow: desktopSlidesToShow,
      slidesToScroll: 1,
      mobileFirst: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 740,
          settings: "unslick"
        }
      ]
    });
  });

  $(".collection-list-sec-list").slick({
      arrows:true,
      dots: true,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });

  $(".trusted-stars-list").slick({
      arrows:true,
      dots: true,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $(".real-results-list").slick({
      arrows:true,
      dots: true,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $('.product-offer-header').click(function(){
   $(this).toggleClass('active');
   $(this).next().slideToggle();
  });
  $("body").on("click", ".product-offer-code-block", function () {
    var copy_text = $(this).find('.product-offer-copy-code');
    var text = $(this).find('.product-offer-code').text();
    var $temp = $("<input>");
      
    $("body").append($temp);
    $temp.val(text).select();
    document.execCommand("copy");
    $temp.remove();
    copy_text.html('Copied');
      
    setTimeout(function () {
      copy_text.html('Copy');
    }, 1000);
  });

    //BUNDLE PAGE
  var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
  function activecheck(addedcnt,bundle_price,bundle_compare_price){
    if(addedcnt == parseInt($('.bundle-product-list').attr('data-bundleitemcnt'))){
      $('.quantity-selector .quantity-selector__button:last-child').attr('disabled','disabled');
      $('.bundle-product-item__cta:not(.added)').attr('disabled','disabled');
      $('.bundle-add_to_cart_button').html(`<span class="loader-button__text"><span class="product-item__cta-text">Checkout</span></span><span class="loader-button__loader"><div class="spinner"><svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle></svg></div></span>`).addClass('readytoadd button--gradient').removeClass('button--outline');
      $('.bundle-preview_cart-prices').show();
    }else{
      $('.quantity-selector .quantity-selector__button:last-child').removeAttr('disabled');
      $('.bundle-product-item__cta:not(.added)').removeAttr('disabled');
      $('.bundle-add_to_cart_button').html('Checkout').addClass('button--outline').removeClass('readytoadd button--gradient');
      $('.bundle-preview_cart-prices').hide();
    }
    $('.bundle-preview_cart-prices .price--compare').html(formatMoney(bundle_price, currencyFormat));
    
    if(addedcnt > 0){
      $('.bundle-preview_cart').show();
    }else{
      $('.bundle-preview_cart').hide();
    }
  }

  var addedcnt = 0;
  var bundle_price = 0;
  var bundle_compare_price = 0;
  $('body').on('click', '.bundle-product-item__cta', function(e){
    e.preventDefault();
    addedcnt += 1;
    bundle_compare_price += parseInt($(this).closest('.product-item').attr('data-product-compareprice'));
    bundle_price += parseInt($(this).closest('.product-item').attr('data-product-price'));

    var prevval = $(this).closest('.bundle-product-item__cta-wrapper').find('.quantity-selector input').val();
    $(this).closest('.bundle-product-item__cta-wrapper').find('.quantity-selector input').val(parseInt(prevval) + 1);
console.log(bundle_compare_price)
    activecheck(addedcnt,bundle_price,bundle_compare_price);    

    // $(this).attr("disabled","disabled").addClass('added button--outline').removeClass('button--gradient').html(`Added`);
    // $(this).before(`<span class="bundle-product-item__cta-remove text--xsmall">x</span>`);

    var featuredimage = $(this).closest('.product-item').attr('data-featuredimage');
    var itembox = `<div class="bundle-preview_cart-item hasicon" 
    data-vid="${$(this).closest('.product-item').attr('data-variant-id')}"
    data-pid="${$(this).closest('.product-item').attr('data-product-id')}"
    data-price="${$(this).closest('.product-item').attr('data-product-price')}"
    data-compare_price="${parseInt($(this).closest('.product-item').attr('data-product-compareprice'))}"
    data-qty="1"
    >
      <div class="bundle-preview_cart-item-wrapper">
        <img src="${featuredimage}" loading="lazy" width="50" height="50" alt="">
        <div class="bundle-preview_car-item-remove text--xsmall">x</div>
        <div class="bundle-preview_car-item-qty text--xsmall">x1</div>
      </div>
    </div>`;
    $('.bundle-preview_cart-items').append(itembox);
    $(this).hide().closest('.bundle-product-item__cta-wrapper').find('.quantity-selector').show();

    
    // var itembox = `<div class="bundle-preview_cart-item-wrapper">
    // <img src="${featuredimage}" loading="lazy" width="50" height="50" alt=""><div class="bundle-preview_car-item-remove text--xsmall">x</div></div>`; 

    // $('.bundle-preview_cart-item.hasblank').first().html(itembox);
    // $('.bundle-preview_cart-item.hasblank').first().attr('data-vid',$(this).closest('.product-item').attr('data-variant-id')).attr('data-pid',$(this).closest('.product-item').attr('data-product-id')).attr('data-price',$(this).closest('.product-item').attr('data-product-price')).removeClass('hasblank');    
  });

  $('body').on('click', '.bundle-product-item__cta-wrapper .quantity-selector .quantity-selector__button:last-child', function(e){
    e.preventDefault();
    addedcnt += 1;
    var prevval = $(this).closest('.quantity-selector').find('input').val();
    bundle_compare_price += parseInt($(this).closest('.product-item').attr('data-product-compareprice'));
    bundle_price += parseInt($(this).closest('.product-item').attr('data-product-price'));
    activecheck(addedcnt,bundle_price,bundle_compare_price);
    $('.bundle-preview_cart-item[data-vid="'+$(this).closest('.product-item').attr('data-variant-id')+'"]').attr('data-qty',prevval).find('.bundle-preview_car-item-qty').html(`x${prevval}`);
  });

  $('body').on('click', '.bundle-product-item__cta-wrapper .quantity-selector .quantity-selector__button:first-child', function(e){
    e.preventDefault();    
    addedcnt = addedcnt - 1;
    var prevval = parseInt($(this).closest('.quantity-selector').find('input').val());
    bundle_compare_price = bundle_compare_price - parseInt($(this).closest('.product-item').attr('data-product-compareprice'));
    bundle_price = bundle_price - parseInt($(this).closest('.product-item').attr('data-product-price'));
    activecheck(addedcnt,bundle_price,bundle_compare_price); 
    if(prevval == 0){
      console.log('iffff');
      $('.bundle-preview_cart-item[data-vid="'+$(this).closest('.product-item').attr('data-variant-id')+'"]').remove();  
      $(this).closest('.quantity-selector').hide();
      $(this).closest('.bundle-product-item__cta-wrapper').find('.bundle-product-item__cta').show();
    }else{
      $('.bundle-preview_cart-item[data-vid="'+$(this).closest('.product-item').attr('data-variant-id')+'"]').attr('data-qty',prevval).find('.bundle-preview_car-item-qty').html(`x${prevval}`);
    }
  });

  // $('body').on('click', '.bundle-product-item__cta-remove', function(e){
  //   e.preventDefault();    
  //   addedcnt = addedcnt - 1;
  //   bundle_compare_price = bundle_compare_price - parseInt($(this).next().attr('data-price'));
  //   activecheck(addedcnt,bundle_compare_price); 

  //   $(`.product-item[data-variant-id="${$(this).closest('.bundle-preview_cart-item').attr('data-vid')}"]`).find('.quantity-selector').hide().find('input').val(0);
  //   $(`.product-item[data-variant-id="${$(this).closest('.bundle-preview_cart-item').attr('data-vid')}"]`).find('.bundle-product-item__cta').show();
  //   $(this).closest('.bundle-preview_cart-item').prev().remove();
  //   $(this).closest('.bundle-preview_cart-item').remove();

  //   // $(this).next().removeAttr("disabled").removeClass('added button--outline').addClass('button--gradient').html(`Add to box`);
  //   // $(`.bundle-preview_cart-item[data-pid="${$(this).closest('.product-item').attr('data-product-id')}"]`).addClass('hasblank').removeAttr('data-pid').removeAttr('data-vid').removeAttr('data-price').html('<div class="bundle-preview_cart-item-wrapper">Add</div>');
  //   // $(this).remove();
  // });

  $('body').on('click','.bundle-preview_car-item-remove', function(){
    addedcnt = addedcnt - $(this).closest('.bundle-preview_cart-item').attr('data-qty');
    bundle_compare_price = bundle_compare_price - (parseInt($(this).closest('.bundle-preview_cart-item').attr('data-compare_price')) * parseInt($(this).closest('.bundle-preview_cart-item').attr('data-qty')));
    bundle_price = bundle_price - (parseInt($(this).closest('.bundle-preview_cart-item').attr('data-price')) * parseInt($(this).closest('.bundle-preview_cart-item').attr('data-qty')));    
    activecheck(addedcnt,bundle_compare_price); 

    $(`.product-item[data-variant-id="${$(this).closest('.bundle-preview_cart-item').attr('data-vid')}"]`).find('.quantity-selector').hide().find('input').val(0);
    $(`.product-item[data-variant-id="${$(this).closest('.bundle-preview_cart-item').attr('data-vid')}"]`).find('.bundle-product-item__cta').show();
    $(this).closest('.bundle-preview_cart-item').remove();
  });

  document.addEventListener('cart:updated', function(event) {
    var cart = event.detail.cart; // Get the updated content of the cart
    var packging_item = window.customthemeVariables.cartsettings.packging_item;
    var haspackateitem = cart.items.filter(function(item){
      return item.id == packging_item['variants'][0].id
    });
    console.log(haspackateitem);
    if(cart['item_count'] == 1 && haspackateitem.length > 0){
      var updateData = {};        
      updateData[packging_item['variants'][0].id] = 0;
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {
          updates: updateData
        },
        dataType: 'json',
        async: true,
        error: function (jqXHR, textStatus, errorThrown) {
          console.log('error')            
        },
        success: function(data) {   
          console.log('success')
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true
          }));
        }
        
      });
    }
  });

  $('body').on('click','.bundle-add_to_cart_button.readytoadd', function(){
    $(this).attr("aria-busy",true);
    var items = [];
    $(this).closest('.bundle-preview_cart-main').find('.bundle-preview_cart-item:not(.hasblank)').each(function(i,v){
      var val = $(this).attr('data-vid');         
      var qty = $(this).attr('data-qty');         
       items.push({
        quantity: qty,
        id: val
      });   
    });      
    
    var data = {items};
    console.log('data',data)
    // var data = theme.utils.serialize(this.form);
   
    fetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(function(data) {      
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      // document.getElementById('mini-cart').open = true;
      onCheckoutClick(this);
      $(this).removeAttr("aria-busy");
      $('.bundle-product-item__cta-wrapper').find('.quantity-selector').hide().find('.quantity-selector__input').val(0);
      $('.bundle-product-item__cta-wrapper').find('.bundle-product-item__cta').show();
      $('.bundle-preview_cart-items .bundle-preview_cart-item').remove();
      addedcnt = 0;
      bundle_price = 0;
      activecheck(0,bundle_price,bundle_compare_price);     
    }.bind(this));  
    
  });

  $('body').on('click','.packaging-addone [data-addpackaging] ', function(){
    $(this).attr("aria-busy",true);
    var items = [];
    var val = $(this).attr('data-itemid');         
     items.push({
      quantity: 1,
      id: val
    });
    
    var data = {items};
    console.log('data',data)
    // var data = theme.utils.serialize(this.form);
   
    fetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(function(data) {      
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      document.getElementById('mini-cart').open = true;
      $(this).removeAttr("aria-busy");
    }.bind(this));  
    
  });

  $(".announcement-bar-sec-list").slick({
      arrows:false,
      dots: false,
      infinite: true,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 3000,
      responsive: [
      {
        breakpoint: 740,
        settings: "unslick"
      }
    ]
  });

  $(".product-ingredients-list").slick({
      arrows:true,
      dots: true,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '80px',
          infinite: true
        }
      }
    ]
  });

  $('body').on('click','.product-description-inner', function(){
    $(this).find('.product-description-title').toggleClass('active');
    $(this).find('.product-description-text').slideToggle();
  });

  document.querySelectorAll('.slick-dots').forEach(parent => {
  if (parent.children.length === 1) {
    parent.style.display = 'none'; // Hide the parent
  }
  });
 
  $('body').on('click','.article-table-nav .scroll_link_selector a', function(){
    var selectr = $(this).attr('data-toscroll');
    console.log('selectr',selectr);
    var mm = $(this).closest('.article__inner').find('.article__content h2.'+selectr);
    if(mm.length > 0){
      $('html, body').animate({
        scrollTop: mm.offset().top - 250
      }); 
    }    
  });

  function setCookie(name, value, days) {
    var d = new Date;
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
  }
      
  $('body').on('click','.ctryModal-Content .stay_here_button', function(){
    $(".ctryModal-Content-overlay").removeClass('active');
    $(".ctryModal-Content").removeClass('active');
    $("body").removeClass('overflow-hidden');
    var delaydays = parseInt($(this).closest('.ctryModal-Content').attr('data-delaydays'));
    setCookie('redirectchoice',true,delaydays);
  });

  if (!localStorage.getItem("popupShown")) {
    setTimeout(function () {
      $(".secondary-popup-wraper").attr("open", true);
      $("body").css("overflow", "hidden");
      localStorage.setItem("popupShown", "true"); // Store flag in localStorage
    }, 8000);
  }
  
  $(".sec-popup-modal-close, .sec-popup-modal__overlay").click(function () {
    $(".secondary-popup-wraper").removeAttr('open');
    $("body").css("overflow", "auto"); // Restore scrolling
  });

  function existingDiscounts(){
    const discountCodes = [];
    const discountPills = $('.existingDiscounts').find('.cart-discount__pill');
    for (const pill of discountPills) {
      if (typeof $(pill).attr('data-discount-code') === 'string') {
        discountCodes.push($(pill).attr('data-discount-code'));
      }
    }
    
    return discountCodes;
  }

  $('body').on('click','[data-inputapply]', function(){
    $('.offer_input_err').remove();
    var _this = $(this);
    _this.attr('disabled','disabled');
    _this.attr('aria-busy','true');
    var sectionId = _this.closest('cart-drawer').attr('section');
    var discountCodeValue = _this.closest('.cart-coupon_offer-input').find('.coupon_code_input').val();
    if(discountCodeValue == ''){
      _this.closest('.cart-coupon_offer-input').after('<p class="offer_input_err">Please enter the code above.</p>');
      _this.removeAttr('disabled','disabled');
      _this.removeAttr('aria-busy','true');
      return;
    }
    var existingDiscountsValue = existingDiscounts();
    
    if (existingDiscountsValue.includes(discountCodeValue)) return;
    
    async function getupdatedata(){     
      let response = await fetch(`${window.themeVariables.routes.cart_update_url}.js`, {
        method: "POST", // HTTP method (GET, POST, PUT, DELETE, etc.)
        headers : {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          discount: [...existingDiscountsValue, discountCodeValue].join(','),
          sections: [sectionId]
        })
      });
      const data = await response.json();
      return data;
    }
    getupdatedata().then(data => {
      console.log(data);
      if (data.discount_codes.find((discount) => {
          return discount.code === discountCodeValue && discount.applicable === false;
        })
      ) {
        console.log('ifffff');
        _this.closest('.cart-coupon_offer-input').after('<p class="offer_input_err">This discount code is not applicable on your cart.</p>');
        _this.removeAttr('disabled','disabled');
        _this.removeAttr('aria-busy','true');
        return;
      }
      console.log('elsssssss');
      const newHtml = data.sections[sectionId];
      const parsedHtml = new DOMParser().parseFromString(newHtml, 'text/html');
      console.log(parsedHtml);
      $('.mini-cart-drawer-content').html($(parsedHtml).find('.mini-cart-drawer-content').html());
      $('.mini-cart__drawer-footer').html($(parsedHtml).find('.mini-cart__drawer-footer').html());      
      $('#coupon-offers .cart-coupon_offer-content').html($(parsedHtml).find('#coupon-offers .cart-coupon_offer-content').html());      
      
    });
  });
  
  $('body').on('click','[data-applybutton]', function(){
    var _this = $(this);
    _this.attr('disabled','disabled');
    _this.attr('aria-busy','true');
    var sectionId = $(this).closest('cart-drawer').attr('section');
    var discountCodeValue = $(this).attr('coupon');
    var existingDiscountsValue = existingDiscounts();
    
    if (existingDiscountsValue.includes(discountCodeValue)) return;
    
    async function getupdatedata(){     
      let response = await fetch(`${window.themeVariables.routes.cart_update_url}.js`, {
        method: "POST", // HTTP method (GET, POST, PUT, DELETE, etc.)
        headers : {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          discount: [...existingDiscountsValue, discountCodeValue].join(','),
          sections: [sectionId]
        })
      });
      const data = await response.json();
      return data;
    }
    getupdatedata().then(data => {
      console.log(data);
      if (data.discount_codes.find((/** @type {{ code: string; applicable: boolean; }} */ discount) => {
          return discount.code === discountCodeValue && discount.applicable === false;
        })
      ) {
        _this.closest('.cart-coupon_offer_item').append('<p class="offer_input_err">This discount code is not applicable on your cart.</p>');
        setTimeout(function(){
          _this.closest('.cart-coupon_offer_item').find('.offer_input_err').remove();
        },3000);
        _this.removeAttr('disabled','disabled');
        _this.removeAttr('aria-busy','true');
        return;
      }
      
      const newHtml = data.sections[sectionId];
      const parsedHtml = new DOMParser().parseFromString(newHtml, 'text/html');
      console.log(parsedHtml);
      $('.mini-cart-drawer-content').html($(parsedHtml).find('.mini-cart-drawer-content').html());
      $('.mini-cart__drawer-footer').html($(parsedHtml).find('.mini-cart__drawer-footer').html());      
      $('#coupon-offers .cart-coupon_offer-content').html($(parsedHtml).find('#coupon-offers .cart-coupon_offer-content').html());      
      
      // document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
      //   bubbles: true,
      //   detail: {
      //     cart: data
      //   }
      // }));
    });
  });

  $('body').on('click','[data-removecode]', function(){
    var _this = $(this);
    if(!_this.hasClass('cart-discount__pill-remove')){
      _this.attr('disabled','disabled');
      _this.attr('aria-busy','true');
    }
    var sectionId = $(this).closest('cart-drawer').attr('section');
    var discountCodeValue = $(this).attr('data-discount-code');
    var existingDiscountsValue = existingDiscounts();
    console.log(existingDiscountsValue)
    const index = existingDiscountsValue.indexOf(discountCodeValue);
    if (index === -1) return;

    existingDiscountsValue.splice(index, 1);
    
    async function getupdatedata(){     
      let response = await fetch(`${window.themeVariables.routes.cart_update_url}.js`, {
        method: "POST", // HTTP method (GET, POST, PUT, DELETE, etc.)
        headers : {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ 
          discount: existingDiscountsValue.join(','),
          sections: [sectionId]
        })
      });
      const data = await response.json();
      return data;
    }
    getupdatedata().then(data => {
      console.log(data);
      const newHtml = data.sections[sectionId];
      const parsedHtml = new DOMParser().parseFromString(newHtml, 'text/html');
      console.log(parsedHtml);
      $('.mini-cart-drawer-content').html($(parsedHtml).find('.mini-cart-drawer-content').html());
      $('.mini-cart__drawer-footer').html($(parsedHtml).find('.mini-cart__drawer-footer').html());      
      $('#coupon-offers .cart-coupon_offer-content').html($(parsedHtml).find('#coupon-offers .cart-coupon_offer-content').html());      

      // document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
      //   bubbles: true,
      //   detail: {
      //     cart: data
      //   }
      // }));
    });
  });

  $('body').on('click', '.mc-cfp-pro-item-btn-add_button', function (e) {
    e.preventDefault();
    $('.mc-cfp-pro-item-btn-add_button').attr('disabled', 'disabled');
    this.setAttribute('aria-busy', 'true');
    var variant_id = parseInt($(this).attr('variant_id'));
    var claim_item_count = parseInt($(this).attr('data-claim-number'));
    var _this = this;
    const line_item_data = JSON.stringify({ quantity: 1, id: variant_id, properties: { '_personalize': 'free_claim', '_claimitemcount': claim_item_count } })
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: line_item_data,
      contentType: 'application/json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        $(_this).setAttribute('disabled', 'disabled');
        $(_this).setAttribute('aria-busy', 'true');
        alert(response.description);
      },
      success: function() {
        if (document.body.classList.contains('template-cart')) {
          location.reload();
        }else{
          $.getJSON("/cart.js", function (cart) {
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: { cart }
            })); 
          });
          $(_this).removeAttr('disabled');
          $(_this).removeAttr('aria-busy');
          $(_this).removeClass('loading');
        }
        // console.log('success');
      }
    })
  })

  // function removeFreeProductIfNeeded() {
  //   const MIN_AMOUNT = Number($('#mini-cart').data('freelimit')) * 100;
  //   const MIN_AMOUNT_2 = Number($('#mini-cart').data('freelimit2')) * 100;  
  //   console.log('MIN_AMOUNT',MIN_AMOUNT);
  //   $.getJSON('/cart.js', function(cart) {
  //     console.log('cart-total_price', cart.total_price);
  //     if (cart.total_price >= MIN_AMOUNT) return;
  //     const freeItem = cart.items.find(item =>
  //       item.properties &&
  //       item.properties._free_product_type === 'freeLimit'
  //     );
  //     if (!freeItem) return;
  //     $.ajax({
  //       type: 'POST',
  //       url: '/cart/change.js',
  //       data: JSON.stringify({
  //         id: freeItem.key,
  //         quantity: 0
  //       }),
  //       contentType: 'application/json',
  //       error: function(jqXHR, textStatus, errorThrown){
  //         var response = $.parseJSON(jqXHR.responseText);
  //         alert(response.description);
  //       },
  //       success: function() {
  //         if (document.body.classList.contains('template-cart')) {
  //           location.reload();
  //         }else{
  //           $.getJSON("/cart.js", function (cart) {
  //             document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
  //               bubbles: true,
  //               detail: { cart }
  //             })); 
  //           });
  //         }
  //       }
  //     });
  //   })
  // }

  function removeFreeProductIfNeeded(cart) {

    var found = 0;
    var item1;
    var item2;

    $(cart.items).each(function(i,e){
      if (e.properties && e.properties._claimitemcount) {
        if(e.properties._claimitemcount === 1){
          item1 = e;
        }else if(e.properties._claimitemcount === 2){
          item2 = e;
        }
        found += 1;
      }
    });

    var cnttt = 0;
    var updateData = {};       
    console.log(item1, item2)
    if(cart.original_total_price < parseInt(window.themeVariables.settings.freeitem_firstthreshold) && found == 1 && found == 2){
      updateData[item1.id] = 0;
      updateData[item2.id] = 0;
      cnttt++;
    }else if(cart.original_total_price < parseInt(window.themeVariables.settings.freeitem_firstthreshold) && found == 1){
      updateData[item1.id] = 0;
      cnttt++;
    }else if(cart.original_total_price < parseInt(window.themeVariables.settings.freeitem_secondthreshold) && found == 2){
      updateData[item2.id] = 0;
      cnttt++;
    }
    console.log('itemmmsdfsdf',updateData)
    if(cnttt > 0){
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {
          updates: updateData
        },
        dataType: 'json',
        success: function () {

          if (document.body.classList.contains('template-cart')) {
            location.reload();
          } else {

            $.getJSON("/cart.js", function (cart) {

              document.documentElement.dispatchEvent(
                new CustomEvent("cart:refresh", {
                  bubbles: true,
                  detail: { cart }
                })
              );

            });

          }

        }
      });
    }
  }

  document.documentElement.addEventListener('cart:refresh', function (event) {
    console.log(event.detail.cart);
    if(event.detail.cart){
      removeFreeProductIfNeeded(event.detail.cart);
    }else{
      $.getJSON('/cart.js', function(cart) {
        removeFreeProductIfNeeded(cart);
      });
    }
    
  });

});

